import {
  type MatchedSiteMaterialV2QualityData,
  type MaterialComponentValue,
  type MaterialProductComponentValue,
  QualityOutputMetricEnum,
} from 'api';

import type { QualityData } from '../../types';
import { rankMaterialComponents } from '../rankMaterialComponents/rankMaterialComponents';

export const getAvailableQualityDataForMaterialComponents = (
  qualityData: MatchedSiteMaterialV2QualityData,
  materialComponents: MaterialProductComponentValue[] | MaterialComponentValue[]
): QualityData[] => {
  if (!qualityData) return [];
  const identicalQualityData: QualityData[] = [];

  const sortedMaterialComponents = rankMaterialComponents(materialComponents);
  sortedMaterialComponents.forEach((materialComponent) => {
    const qualityOutputMetric = materialComponent.supported_component.component.quality_output_metric;
    if (qualityOutputMetric && qualityData[qualityOutputMetric]) {
      identicalQualityData.push({
        properties: qualityData[qualityOutputMetric],
        quality_output_metric: qualityOutputMetric,
      });
    }
  });

  if (
    qualityData['UBC']?.WEIGHT_CONTENT &&
    !identicalQualityData.some(
      (qualityDataItem) => qualityDataItem.quality_output_metric === QualityOutputMetricEnum.UBC
    )
  ) {
    identicalQualityData.push({
      properties: qualityData['UBC'],
      quality_output_metric: QualityOutputMetricEnum.UBC,
    });
  }

  return identicalQualityData;
};
